<template>
  <option-general value="time" :label="$t('edit.sidebar.by_time_on_page')">
    <div class="box-input-group box-input-time">
      <i class="box-input-group__icon icon-kp-clock"></i>
      <input
        class="box-input"
        type="number"
        :value="boxConfig.advanced.exibition_mode_time_value"
        @change="boxUpdateConfig({ item: 'advanced', key: 'exibition_mode_time_value', value: $event.target.value });">
      <span class="box-input-group-label">{{ $t('general.labels.seconds') }}</span>
    </div>
  </option-general>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import OptionGeneral from './general/Main.vue';

export default {
  components: {
    OptionGeneral,
  },
  methods: mapActions([
    'boxUpdateConfig',
  ]),
  computed: mapGetters({
    boxConfig: 'boxConfig',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Time.vue?5fae9c36
 **/